/*
 * Lost Boy quick-add — the "+" / "Add to Cart" on product cards.
 *
 * Deliberately a CLASSIC script with NO static imports: the submit listener
 * attaches the instant this file runs, with zero dependency on Horizon's ES
 * modules or the external @shopify/events bundle. That guarantees the form
 * NEVER does a native navigation to /cart — even if those modules are slow,
 * blocked, or error. The add itself is a plain fetch to /cart/add.js.
 *
 * The richer Horizon cart refresh (drawer morph via its own event) is attempted
 * as a best-effort enhancement via dynamic import; if that isn't available we
 * fall back to refreshing the cart sections ourselves. Either way the item is
 * added, the bubble updates, and the drawer opens.
 */
(function () {
  // A page can render this <script> more than once (e.g. the homepage has both
  // Shop Categories and New Releases). A classic script executes per tag, so guard
  // against attaching the submit listener twice — otherwise one click adds twice.
  if (window.__lbQuickAddInit) return;
  window.__lbQuickAddInit = true;

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('form[data-lb-quick-add]') : null;
    if (!form) return;
    event.preventDefault();
    quickAdd(form);
  });

  function routes() {
    return (window.Theme && Theme.routes) || {};
  }

  function quickAdd(form) {
    var button = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput ? idInput.value : null;
    if (!variantId) {
      form.submit();
      return;
    }

    if (button) button.setAttribute('disabled', '');
    form.classList.add('is-adding');

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId && sectionIds.indexOf(c.dataset.sectionId) === -1) {
        sectionIds.push(c.dataset.sectionId);
      }
    });

    var addUrl = routes().cart_add_url || '/cart/add.js';
    var cartUrl = (routes().cart_url || '/cart') + '.js';

    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        // Shopify returns a non-empty `status` (422 etc.) on failure — e.g. sold out.
        if (!res.ok || res.data.status) {
          flash(button, 'error', res.data.description || res.data.message);
          cleanup(button, form);
          return;
        }
        flash(button, 'added');
        return refreshCart(res.data, cartUrl).then(function () {
          openDrawer();
          cleanup(button, form);
        });
      })
      .catch(function () {
        // Genuine network failure before the add — let the native form submit so
        // the customer can still add the item rather than silently doing nothing.
        cleanup(button, form);
        form.submit();
      });
  }

  function refreshCart(addResponse, cartUrl) {
    return fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBubbles(cart.item_count);
        return dispatchHorizonEvent(cart, addResponse).catch(function () {
          // Horizon event module unavailable — refresh the cart sections ourselves.
          manualMorph(addResponse);
        });
      })
      .catch(function () {
        manualMorph(addResponse);
      });
  }

  function dispatchHorizonEvent(cart, addResponse) {
    // Best-effort: reuse Horizon's own event so its cart drawer/items morph exactly
    // as they do for a normal add. Dynamic import so a failure here never breaks add.
    return import('@shopify/events').then(function (mod) {
      var Evt = mod && mod.CartLinesUpdateEvent;
      if (!Evt || typeof Evt.createPromise !== 'function') throw new Error('no event');
      var deferred = Evt.createPromise();
      document.dispatchEvent(
        new Evt({
          action: 'add',
          context: 'product',
          lines: [],
          promise: deferred.promise
        })
      );
      deferred.resolve({
        cart: Evt.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          itemCount: 1,
          source: 'lb-quick-add',
          sections: addResponse.sections,
          didError: false
        }
      });
    });
  }

  function manualMorph(addResponse) {
    if (!addResponse || !addResponse.sections) return;
    Object.keys(addResponse.sections).forEach(function (sid) {
      var html = addResponse.sections[sid];
      var wrapper = document.getElementById('shopify-section-' + sid);
      if (!html || !wrapper) return;
      try {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('#shopify-section-' + sid);
        wrapper.innerHTML = inner ? inner.innerHTML : html;
      } catch (e) {
        /* leave the stale section rather than break the page */
      }
    });
  }

  function updateBubbles(count) {
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      var countEl = icon.querySelector('.cart-bubble__count') || icon.querySelector('[ref="cartBubbleCount"]');
      var bubble = icon.querySelector('.cart-bubble');
      if (countEl) countEl.textContent = count < 100 ? String(count) : '';
      if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      icon.classList.toggle('lb-header__cart-icon--has-cart', count > 0);
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('cart-drawer');
    try {
      if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) drawer.open();
    } catch (e) {
      /* drawer mid-transition — item is added regardless */
    }
  }

  function cleanup(button, form) {
    if (button) button.removeAttribute('disabled');
    form.classList.remove('is-adding');
  }

  function flash(button, kind, title) {
    if (!button) return;
    if (title) button.title = title;

    // Wide "Add to Cart" text button: swap the label so the state reads clearly.
    if (button.classList.contains('lb-card__atc')) {
      if (!button.dataset.lbLabel) button.dataset.lbLabel = button.textContent;
      button.classList.add(kind === 'added' ? 'lb-card__atc--added' : 'lb-card__atc--error');
      button.textContent = kind === 'added' ? 'Added ✓' : 'Try again';
      setTimeout(function () {
        button.classList.remove('lb-card__atc--added', 'lb-card__atc--error');
        button.textContent = button.dataset.lbLabel;
      }, 1500);
      return;
    }

    // Compact "+" button: swap colour + glyph via CSS.
    var cls = kind === 'added' ? 'lb-card__plus--added' : 'lb-card__plus--error';
    button.classList.add(cls);
    setTimeout(function () {
      button.classList.remove(cls);
    }, 1400);
  }
})();

/* Free Gifts (BOGOS) popup must sit ABOVE the modal cart drawer, not behind it.
   The drawer is a modal <dialog> (browser "top layer") which renders above ALL
   content regardless of z-index, so the gift popup was hidden behind it. We move
   the popup INTO the open dialog (same top layer, higher z-index) while the drawer
   is open, then return it home when it closes. Lives here (not only lb-home.js)
   because lb-home.js is aggressively edge-cached; guarded so it runs only once. */
(function lbGiftPopupAboveDrawer2() {
  if (window.__lbGiftFix) return;
  window.__lbGiftFix = true;

  var SEL = '.freegifts-main-container.sca-modal-fg';
  var VISIBLE = 'sca-is-visible-fg';

  function modalDialog() {
    var dialogs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dialogs.length; i++) {
      try {
        if (dialogs[i].matches(':modal')) return dialogs[i];
      } catch (e) {}
    }
    return null;
  }

  var moved = null;
  var home = null;

  function place() {
    var gift = document.querySelector(SEL);
    var visible = gift && gift.classList.contains(VISIBLE);
    var dialog = modalDialog();

    if (gift && visible && dialog) {
      if (gift.parentElement !== dialog) {
        if (!home) home = gift.parentElement;
        dialog.appendChild(gift);
        gift.classList.add('lb-gift-over-drawer');
        moved = gift;
      }
    } else if (moved) {
      if (home && moved.parentElement !== home) home.appendChild(moved);
      moved.classList.remove('lb-gift-over-drawer');
      moved = null;
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      place();
    });
  }

  function start() {
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'open']
    });
    place();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
